/* eslint-disable */

/** select columns of table "argo.vw_active_location_calendar" */
export enum ArgoVwActiveLocationCalendarSelectColumn {
  /** column name */
  ActiveCalendarId = 'active_calendar_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  DefaultCalendarId = 'default_calendar_id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  QueryTime = 'query_time'
}

